import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {deleteWishCode, getWishCodes, uploadWishCodes} from "./ActionCreators";
import {IWishCode, IWishCodeState} from "./Helper";

const initialValue: IWishCodeState = {
    fetchCodesLoading: false,
    items: [],
    deleteCodeLoading: false,
    uploadCodesLoading: false,
}

const wishCodeSlice = createSlice({
    name: SliceNames.WISH_CODE,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getWishCodes.pending, (state) => {
                state.fetchCodesLoading = true
            })
            .addCase(
                getWishCodes.fulfilled, (state, action: PayloadAction<IWishCode[]>) => {
                    state.items = action.payload
                    state.fetchCodesLoading = false
                })
            .addCase(
                getWishCodes.rejected, (state) => {
                    state.items = []
                    state.fetchCodesLoading = false
                })
            .addCase(
                deleteWishCode.pending, (state) => {
                    state.deleteCodeLoading = true
                })
            .addCase(
                deleteWishCode.fulfilled, (state, action: PayloadAction<string>) => {
                    state.items = [...state.items].filter(c => c.id !== action.payload)
                    state.deleteCodeLoading = false
                })
            .addCase(
                deleteWishCode.rejected, (state) => {
                    state.deleteCodeLoading = false
                })
            .addCase(
                uploadWishCodes.pending, (state) => {
                    state.uploadCodesLoading = true
                })
            .addCase(
                uploadWishCodes.fulfilled, (state) => {
                    state.uploadCodesLoading = false
                })
            .addCase(
                uploadWishCodes.rejected, (state) => {
                    state.uploadCodesLoading = false
                })

    }
})

export default wishCodeSlice.reducer
